import { GregorianCalendar } from '@internationalized/date';

export const createCalendar = () => new GregorianCalendar();
